import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { QuillModule } from "ngx-quill";
import { NgApexchartsModule } from "ng-apexcharts";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxSpinnerModule } from "ngx-spinner";
import { MaterialModule } from "src/app/material.module";
import { RouterModule } from "@angular/router";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkAccordionModule } from "@angular/cdk/accordion";
import { MatDividerModule } from "@angular/material/divider";
import { MatTreeModule } from "@angular/material/tree";
import { GoogleMapsModule } from "@angular/google-maps";

import { MarqueeComponent } from "./components/marquee-component/marquee-component.component";
import { TwoDigitDecimaNumberDirective } from "./directives/two-digit-decimal.directive";
import { ScriptTagValidatorDirective } from './directives/script-tag-validator-directive';
import { PixelTagValidatorDirective } from "./directives/pixel-tag-validator";
import { ColumnResizeDirective } from "./directives/table-column-resizing";
import { DigitOnlyDirective } from "./directives/digit-only-directive";
import { DisableScrollOnNumberDirective } from "./directives/disable-number-scroll.directive";
import { AdvertiserSelectionComponent } from "./components/advertiser-selection/advertiser-selection.component";
import { AgencySelectionComponent } from "./components/agency-selection/agency-selection.component";
import { InformationBoxComponent } from "./information-box/information-box.component";
import { RoundUpPipe } from "./pipes/roundup.pipe";
import { SanitizerUrlPipe } from "./pipes/sanitizer-url.pipe";
import { PreviewComponent } from "./components/preview/preview.component";
import { FormatTimePipe } from "./pipes/time.pipe";
import { NumberExpressionPipe } from "./pipes/number-expression.pipe";
import { CampaignDaypartTargetingComponent } from "./components/campaign-daypart-targeting/campaign-daypart-targeting.component";
import { CommissionComponent } from "./components/commission/non-apnx-commission/commission.component";
import { CreativeEditorComponent } from "./components/creative-editor/creative-editor.component";
import { CampaignDealsTargetingComponent } from "./components/campaign-deals-targeting/campaign-deals-targeting.component";
import { ClientAttributionFeesComponent } from "./components/client-attribution-fees/client-attribution-fees.component";
import { EntityBulkEditComponent } from "./components/entity-bulk-edit/entity-bulk-edit.component";
import { ItemsForBulkEditComponent } from "./components/items-for-bulk-edit/items-for-bulk-edit.component";
import { BdspGeoTargetingComponent } from "./components/bdsp/bdsp-geo-targeting/bdsp-geo-targeting.component";
import { BdspInventoryListingComponent } from "./components/bdsp/bdsp-inventory-listing/bdsp-inventory-listing.component";
import { EntityDashboardEditComponent } from "./components/entity-dashboard-edit/entity-dashboard-edit.component";
import { CreativeNativeOfferPreviewComponent } from "./components/creative-native-offer-preview/creative-native-offer-preview.component";
import { KpiPyramidComponent } from './components/kpi-pyramid/kpi-pyramid.component';
import { TdspGeoTargetingComponent } from "./components/tdsp/tdsp-geo-targeting/tdsp-geo-targeting.component";
import { LocationSelectorComponent } from "./components/location-selector/location-selector.component";
import { CreativePreviewComponent } from "./components/creative-preview/creative-preview.component";
import { CreativeBulkEditComponent } from "./components/creative-bulk-edit/creative-bulk-edit.component";
import { GamblingCountryDatatableComponent } from "./components/gambling-country-datatable/gambling-country-datatable.component";

@NgModule({
  declarations: [
    TwoDigitDecimaNumberDirective,
    ColumnResizeDirective,
    DigitOnlyDirective,
    DisableScrollOnNumberDirective,
    ScriptTagValidatorDirective,
    PixelTagValidatorDirective,
    AdvertiserSelectionComponent,
    AgencySelectionComponent,
    InformationBoxComponent,
    RoundUpPipe,
    SanitizerUrlPipe,
    PreviewComponent,
    FormatTimePipe,
    NumberExpressionPipe,
    CampaignDaypartTargetingComponent,
    CommissionComponent,
    CreativeEditorComponent,
    ClientAttributionFeesComponent,
    CampaignDealsTargetingComponent,
    EntityBulkEditComponent,
    ItemsForBulkEditComponent,
    EntityDashboardEditComponent,
    BdspGeoTargetingComponent,
    BdspInventoryListingComponent,
    MarqueeComponent,
    CreativeNativeOfferPreviewComponent,
    KpiPyramidComponent,
    LocationSelectorComponent,
    CreativePreviewComponent,
    TdspGeoTargetingComponent,
    CreativeBulkEditComponent,
    GamblingCountryDatatableComponent
  ],
  exports: [
    TwoDigitDecimaNumberDirective,
    ColumnResizeDirective,
    DigitOnlyDirective,
    DisableScrollOnNumberDirective,
    ScriptTagValidatorDirective,
    PixelTagValidatorDirective,
    AdvertiserSelectionComponent,
    ClientAttributionFeesComponent,
    CampaignDaypartTargetingComponent,
    CampaignDealsTargetingComponent,
    BdspGeoTargetingComponent,
    BdspInventoryListingComponent,
    ItemsForBulkEditComponent,
    EntityDashboardEditComponent,
    CommissionComponent,
    CreativeEditorComponent,
    MarqueeComponent,
    RoundUpPipe,
    SanitizerUrlPipe,
    FormatTimePipe,
    NumberExpressionPipe,
    AgencySelectionComponent,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    GoogleMapsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MaterialModule,
    NgxMatSelectSearchModule,
    DragDropModule,
    CdkTableModule,
    CdkAccordionModule,
    ScrollingModule,
    MatDividerModule,
    MatCardModule,
    MatTreeModule,
    QuillModule,
    CreativeNativeOfferPreviewComponent,
    TdspGeoTargetingComponent,
    KpiPyramidComponent,
    LocationSelectorComponent,
    NgApexchartsModule,
    CreativeBulkEditComponent,
    GamblingCountryDatatableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    GoogleMapsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MaterialModule,
    NgxMatSelectSearchModule,
    RouterModule,
    DragDropModule,
    CdkTableModule,
    CdkAccordionModule,
    ScrollingModule,
    MatDividerModule,
    NgApexchartsModule,
    MatCardModule,
    MatTreeModule,
    QuillModule.forRoot(),
    TooltipModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SharedModule {}
